/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiGroupHoursOfOperationRequestGroupHoursFromJSON(json) {
    return StreemApiGroupHoursOfOperationRequestGroupHoursFromJSONTyped(json, false);
}
export function StreemApiGroupHoursOfOperationRequestGroupHoursFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'day': !exists(json, 'day') ? undefined : json['day'],
        'startTime': !exists(json, 'start_time') ? undefined : json['start_time'],
        'endTime': !exists(json, 'end_time') ? undefined : json['end_time'],
        'timeZoneId': !exists(json, 'time_zone_id') ? undefined : json['time_zone_id'],
    };
}
export function StreemApiGroupHoursOfOperationRequestGroupHoursToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'day': value.day,
        'start_time': value.startTime,
        'end_time': value.endTime,
        'time_zone_id': value.timeZoneId,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiGroupHoursOfOperationRequestGroupHoursDay;
(function (StreemApiGroupHoursOfOperationRequestGroupHoursDay) {
    StreemApiGroupHoursOfOperationRequestGroupHoursDay["FRIDAY"] = "DAYS_OF_WEEK_FRIDAY";
    StreemApiGroupHoursOfOperationRequestGroupHoursDay["INVALID"] = "DAYS_OF_WEEK_INVALID";
    StreemApiGroupHoursOfOperationRequestGroupHoursDay["MONDAY"] = "DAYS_OF_WEEK_MONDAY";
    StreemApiGroupHoursOfOperationRequestGroupHoursDay["SATURDAY"] = "DAYS_OF_WEEK_SATURDAY";
    StreemApiGroupHoursOfOperationRequestGroupHoursDay["SUNDAY"] = "DAYS_OF_WEEK_SUNDAY";
    StreemApiGroupHoursOfOperationRequestGroupHoursDay["THURSDAY"] = "DAYS_OF_WEEK_THURSDAY";
    StreemApiGroupHoursOfOperationRequestGroupHoursDay["TUESDAY"] = "DAYS_OF_WEEK_TUESDAY";
    StreemApiGroupHoursOfOperationRequestGroupHoursDay["WEDNESDAY"] = "DAYS_OF_WEEK_WEDNESDAY";
})(StreemApiGroupHoursOfOperationRequestGroupHoursDay || (StreemApiGroupHoursOfOperationRequestGroupHoursDay = {}));
//# sourceMappingURL=StreemApiGroupHoursOfOperationRequestGroupHours.js.map